import api from '../utils/api';

// Fetch all resignations
export const getAllResignations = async (headers) => {
  try {
    const response = await api.get('/api/resignations',  headers );
    console.log("resignations", response.data)
    return response.data;
  } catch (error) {
    console.error('Error fetching all resignations:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch a specific resignation by ID
export const getResignationById = async (id, headers) => {
  try {
    const response = await api.get(`/api/resignations/${id}`,  headers );
    console.log("resignation by id", response.data)
    return response.data;
  } catch (error) {
    console.error('Error fetching resignation by ID:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Create a new resignation
export const createResignation = async (resignationData, headers) => {
  try {
    const response = await api.post('/api/resignations', resignationData,  headers );
    return response.data;
  } catch (error) {
    console.error('Error creating resignation:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Update an existing resignation
export const updateResignation = async (id, resignationData, headers) => {
  try {
    console.log("update resignationData ",id, resignationData)
    const response = await api.put(`/api/resignations/${id}`, resignationData,  headers );
    return response.data;
  } catch (error) {
    console.error('Error updating resignation:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Delete a resignation
export const deleteResignation = async (id, headers) => {
  try {
    const response = await api.delete(`/api/resignations/${id}`,  headers );
    return response.data;
  } catch (error) {
    console.error('Error deleting resignation:', error.response ? error.response.data : error.message);
    throw error;
  }
};
